<cm-card class="card">
    <div class="header-container">
        <cm-page-header class="page-header" [hideBackUrl]="true" text="Organization Roles">
            <cm-page-actions
                *ngIf="editPermission"
                [actions]="actions"
                (action)="onPageAction($event)"
            ></cm-page-actions>
        </cm-page-header>
    </div>
    <main class="main">
        <p class="sub-title">
            You may add or edit roles you have in your organization. Roles allow you to treat a group of professionals
            together in reports. They also can control automatic assignments into workflows.
        </p>
        <div class="table-wrapper">
            <cm-smart-table
                *ngIf="rows.length"
                class="table"
                [headers]="tableHeaders"
                [rows]="rows"
                [config]="tableConfig"
                (onRowClick)="editPermission && onPageAction(ORGANIZATION_ROLES_ACTIONS.EDIT_ROLE, $event)"
            >
            </cm-smart-table>
        </div>
        <div><cm-no-content *ngIf="!rows.length" class="no-content" [config]="noContentConfig"></cm-no-content></div>
    </main>
</cm-card>
<ng-template #actionTemplate let-row="row">
    <div class="action-wrapper">
        <div class="action-btn mr-4" (click)="onPageAction(ORGANIZATION_ROLES_ACTIONS.VIEW_CREDENTIALS, row, $event)">
            <span class="cm-link">View Credentials</span>
        </div>
        <div class="action-btn" (click)="onPageAction(ORGANIZATION_ROLES_ACTIONS.EDIT_ROLE, row, $event)">
            <span class="fa fa-pencil"></span>
        </div>
        <div class="action-btn ml-4" (click)="onPageAction(ORGANIZATION_ROLES_ACTIONS.DELETE_ROLE, row, $event)">
            <i class="fa fa-trash"></i>
        </div>
    </div>
</ng-template>
<ng-template #noActiveCredentialsWarningTemplate>
    <div class="modal-body">
        <div class="warning-text">
            You currently have no credentials associated with this role. By associating credentials to a role, you can
            assign onboarding workflows to users and require them to provide information for the credentials associated
            with their role. <br /><br />
            To associate credentials with a role, please contact your Client Services Representative for assistance.
        </div>
    </div>
</ng-template>
